import { jsx as r } from "react/jsx-runtime";
const t = ({ children: e }) => /* @__PURE__ */ r("section", { className: "max-width padded-sides centered mb-lg", children: e });
export {
  t as default
};
